import React from 'react'

import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { FormattedMessage } from 'react-intl'

import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { Game, Firebase } from '../../../../Core'

import * as quizzesSelectors from '../../../Quizzes/quizzes.selectors'
import * as savePointSelector from '../../../SavePoint/savePoint.selectors'

import * as actions from '../endgame.actions'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'

import UserShield from '../../../Components/UserShield'
import FederationFlag from '../../../Components/FederationFlag'
import Podium from './Podium'
import FederationsPodium from './FederationsPodium'
import Summary from './Summary'

class EndGameRanking extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLadder: false,
      federations: false,
    }
  }

  closeScreen() {
    const { removeScreen } = this.props
    removeScreen('end_game')
  }

  renderUserData() {
    const { userData } = this.props
    const { showLadder } = this.state

    let cityLevel = 'map.buildings.city_level.' + userData.cityLevel

    return (
      <React.Fragment>
        <ul className="endgame--user__data">
          <li>
            <span className="endgame--user__position">{userData.position}º</span>
          </li>
          <li>
            <UserShield shield={userData.colonyShield} />
          </li>
          <li>
            <div className="text">
              <FormattedMessage id={cityLevel} />
            </div>
            <div className="text">{userData.colonyName}</div>
            <div className="text">{userData.name}</div>
          </li>
        </ul>
        <div className="endgame--animation">
          <span
            className={`${showLadder ? 'icon-angle-down' : 'icon-angle-up'}`}
            onClick={() => this.setState({ showLadder: !showLadder })}
          >
            {' '}
          </span>
        </div>
      </React.Fragment>
    )
  }

  renderFederationData() {
    const { userFederation } = this.props

    return (
      <ul className="endgame--user__data">
        <li>
          <span className="endgame--user__position">{userFederation.position}º</span>
        </li>
        <li>
          <FederationFlag flag={userFederation.flag} />
        </li>
        <li>
          <div className="text">{userFederation.name}</div>
        </li>
      </ul>
    )
  }

  toRanking() {
    const { addHowlSound, addScreen } = this.props
    let endGame = true

    addHowlSound('button_click_icon')
    endGame ? addScreen('ranking_screen') : this.closeScreen()
    this.closeScreen()
  }

  render() {
    const { showLadder, federations } = this.state
    const { federationsInfo } = this.props

    return (
      <div className="content">
        <div className="endgame  fadeInLeft-animation">
          <div className="endgame--title">
            <FormattedMessage id="endGame.title" />
          </div>
          <div className="position--absolute right center z-index1 federation--position">
            <div className="btn" onClick={() => this.toRanking()}>
              <div className="btn--primary">
                <span className="icon-satelite"> </span>
              </div>
            </div>
            {federationsInfo ? (
              <div className="btn" onClick={() => this.setState({ federations: !federations })}>
                <div className="btn--primary">
                  <span className="icon-repeat-button"> </span>
                </div>
              </div>
            ) : null}
          </div>
          {federations ? <FederationsPodium /> : <Podium />}
          <div className={`endgame--user__info ${showLadder ? 'active' : ''}`}>
            <div className="endgame--user__head">
              {federations ? this.renderFederationData() : this.renderUserData()}
            </div>
            <Summary />
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userData: Firebase.selectors.getUserData(state),
    userFederation: Firebase.selectors.getUserFederation(state),
    disputeList: quizzesSelectors.getDisputesList(state),
    federationsInfo: Firebase.selectors.getFederationsInfo(state),
    surveyActive: savePointSelector.isSurveyCompleted(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
    getReports: bindActionCreators(actions.loadData, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  }
}
EndGameRanking.propTypes = {
  removeScreen: PropTypes.func,
  addHowlSound: PropTypes.func,
  addScreen: PropTypes.func,
  userData: PropTypes.object,
  userFederation: PropTypes.object,
  federationsInfo: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EndGameRanking))
